module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_6_Syd-Local-Health-District@2x.4e7a0ea84c0383c69e7ffbfe4ae48d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_6_Syd-Local-Health-District@2x.png
// module id = 783
// module chunks = 0